import { createAction } from 'redux-actions';

import CogniteViewer from '@cognite/3d-viewer';

// Constants
export const CREATE_VIEWER = '3d/CREATE_VIEWER';
export const RENDER_VIEWER = '3d/RENDER_VIEWER';
export const UNMOUNT_VIEWER = '3d/UNMOUNT_VIEWER';

// Reducer
const initialState = { viewer: null, rendered: false };

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_VIEWER:
      return {
        ...state,
        viewer: action.payload,
      };
    case RENDER_VIEWER:
      return {
        ...state,
        rendered: true,
      };
    case UNMOUNT_VIEWER:
      return {
        ...state,
        rendered: false,
      };
    default:
      return state;
  }
};

export const createViewerAction = createAction(CREATE_VIEWER);
export const renderViewerAction = createAction(RENDER_VIEWER);
export const unmountViewerAction = createAction(UNMOUNT_VIEWER);

// Action creators
export const setupViewer = () => async dispatch => {
  const viewer = new CogniteViewer({
    renderer: {
      downsampleFactor: 1.0,
    },
    api: '0.4',
    project: 'akerbp',
    modelId: 5360336888038988,
    revisionId: 1059523931446784,
    sceneId: 4800418712833533,
  });
  dispatch(createViewerAction(viewer));
};

// Action creators
export const renderViewer = () => async (dispatch, getState) => {
  const { threed: state } = getState();
  if (state.viewer !== null && !state.rendered) {
    dispatch(renderViewerAction());
  }
};
// Action creators
export const unmountViewer = () => async (dispatch, getState) => {
  const { threed: state } = getState();
  if (state.viewer !== null && state.rendered) {
    dispatch(unmountViewerAction());
  }
};

export const actions = {
  setupViewer,
  renderViewer,
  unmountViewer,
};



// WEBPACK FOOTER //
// ./src/modules/threed/ThreeD.js